<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Rawat Inap',
              content:
                'Tidak dapat membuat lebih dari 1 Rawat Inap untuk nomor rawat yang sama',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ranap/save" method="POST" enctype="multipart/form-data"-->

          <div class="row mb-5">
            <div class="col-md-5">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-7">
              <FormRow
                v-for="row in uploadForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Check in Rawat Inap
                </button>
                <button
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => reset('/ranap')"
                >
                  Batalkan
                </button>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import Alert from "@/components/Alert.vue";
import {
  resetForms,
  setPatientIntro,
  setRawatIntro,
  doubleDigit,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  leftForm,
  rightForm,
  uploadForm,
  today,
  time,
} from "@/data/RanapForm.js";
export default {
  name: "RanapForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      validated: false,
      rooms: [],
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      leftForm: leftForm,
      ralan: {},
      doubleDigit: doubleDigit,
      rightForm: rightForm,
      uploadForm: uploadForm,
      formSet: {
        darurat: "",
        no_rawat: "",
        no_rm: "",
        id_kamar: "",
        id_dokter: "",
        id_petugas: "",
        tgl_masuk: today,
        jam_masuk: time,
        dgs_awal: "",
        same_as_ralan: "",
        jumlah: 1,
        satuan: 0,
        tgh_kamar: 0,
        file_permintaan_ranap: "",
        file_pengkajian_awal: "",
        file_asesmen_resiko: "",
        soap_dokter: "",
        soap_perawat: "",
        file_catatan_obat: "",
        file_ringkasan_masuk: "",
        file_resume_medis: "",
        file_resume_pulang: "",
      },
      saveSuccess: false,
      saveFailed: false,
    };
  },
  methods: {
    getDateEnd: function(start, n) {
      ////console.log(start);
      let dt = new Date(start);
      var theDay = new Date();
      theDay.setDate(dt.getDate() + parseInt(n) - 1);
      var day =
        theDay.getFullYear() +
        "-" +
        this.doubleDigit(theDay.getMonth() + 1) +
        "-" +
        this.doubleDigit(theDay.getDate());
      ////console.log(day);
      return day;
    },
    getDaysArray: function(start, n) {
      let arr = [];
      ////console.log(start);
      let dt = new Date(start);
      arr.push(start);
      for (var i = 1; i < n; i++) {
        ////console.log(i);
        var theDay = new Date();
        theDay.setDate(dt.getDate() + i);
        var day =
          theDay.getFullYear() +
          "-" +
          this.doubleDigit(theDay.getMonth() + 1) +
          "-" +
          this.doubleDigit(theDay.getDate());
        ////console.log(day);
        arr.push(day);
      }
      ////console.log(arr);
      return arr;
    },
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      // let formTagihan = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          if (["tgh_kamar", "satuan", "jumlah"].indexOf(key) < 0) {
            formData.append(key, self.formSet[key]);
          } else {
            ////console.log(key);
            ////console.log(self.formSet[key]);
          }
        });
        // let dates = this.getDaysArray(this.formSet.tgl_masuk,this.formSet.jumlah);
        let dateEnd = this.getDateEnd(
          this.formSet.tgl_masuk,
          this.formSet.jumlah
        );
        ////console.log(dates);
        ////console.log(dateEnd);

        try {
          let result = await this.$store.state.HTTP.post("/ranap", formData);
          ////console.log(result);
          if (result.status == "200") {
            // this.saveFailed=false;
            // this.saveSuccess=true;
            let idRanap = result.data.id;
            ////console.log(result);
            let tagihanData = new FormData();
            tagihanData.append("id_ranap", idRanap);
            tagihanData.append("tgl_dari", self.formSet.tgl_masuk);
            tagihanData.append("tgl_sampai", dateEnd);
            tagihanData.append("id_kamar", self.formSet.id_kamar);
            let response = await this.$store.state.HTTP.post(
              "/ranap/tagihan/kamar",
              tagihanData
            );
            ////console.log(response);
            if (response.status == "200") {
              self.saveFailed = false;
              self.saveSuccess = true;
              setTimeout(function() {
                self.saveSuccess = false;
                self.reset(`/ranap/detail/${idRanap}`);
                // self.$router.push(`/ranap/detail/${idRanap}`);
              }, 1000);
            } else {
              self.errors.push(result.status);
              self.saveFailed = true;
            }
          } else {
            ////console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          ////console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        ////console.log("tidak valid");
      }
    },
    reset(url, stay, noTab) {
      // if (this.validated) {
      resetForms(
        this.formSet,
        [this.leftForm, this.rightForm, this.uploadForm],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;

          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = noTab ? "" : "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
    handleChange(e) {
      ////console.log(create);
      ////console.log(this.leftForm);
      ////console.log(this.rightForm);
      ////console.log(this.formSet);
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
      if (e.target.name == "same_as_ralan") {
        ////console.log(e.target.value);

        // this.formSet[e.target.name] = e.target.value;
        this.leftForm[3].columns[0].value = this.formSet[e.target.name];
        if (e.target.value == "Ya") {
          this.formSet["id_dokter"] = this.ralan.id_dokter;
          ////console.log(this.formSet['id_dokter']);
        } else {
          this.formSet["id_dokter"] = "";
        }
        // this.leftForm[2].columns[0].value=this.formSet['id_dokter'];
        // this.$set(this.leftForm[2].columns[0],'value',this.formSet['id_dokter']);
        // this.leftForm.splice(2,1,this.leftForm[2]);
        // this.leftForm.splice(3,1,this.leftForm[3]);
        ////console.log(this.leftForm);
      } else if (e.target.name == "id_kamar") {
        this.setPrice(e.target.value);
      } else if (e.target.name == "jumlah") {
        this.formSet.jumlah = e.target.value;
        this.formSet.tgh_kamar =
          parseInt(this.formSet.satuan) * parseInt(this.formSet.jumlah);
        this.rightForm[1].columns[0].value = this.formSet.jumlah;
        this.rightForm[1].columns[2].value = this.formSet.tgh_kamar;
      }
    },
    setPrice: async function(id_kamar) {
      ////console.log(id_kamar);
      ////console.log(this.rooms);
      // let result = await this.$store.state.HTTP.get(`ranap/fasilitas/kamar/${id_kamar}`);
      ////console.log(result);
      let room = this.rooms.find(function(room) {
        return room.id == id_kamar;
      });
      ////console.log(room);
      if (room) {
        this.formSet.satuan = room.biaya;
      } else {
        this.formSet.satuan = 0;
      }
      this.rightForm[1].columns[1].value = this.formSet.satuan;
      this.formSet.tgh_kamar =
        parseInt(this.formSet.satuan) * parseInt(this.formSet.jumlah);
      this.rightForm[1].columns[2].value = this.formSet.tgh_kamar;
      // this.rightForm()
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      ////console.log(self.formSet);
      let forms = [this.leftForm, this.rightForm, this.uploadForm].map(function(
        form
      ) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            ////console.log(column.value);
            ////console.log(column.optional);
            ////console.log(self.formSet[column.name]);
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else if (
              [
                "number",
                "money",
                "addon-right",
                "addon-left",
                "percentage",
              ].indexOf(column.type) > -1 &&
              !column.negativeValue &&
              parseInt(self.formSet[column.name]) < 0
            ) {
              valid = false;
              column.error = "Nilai yang diisi tidak boleh negatif";
            } else {
              column.error = "";
            }
            if (self.formSet[column.name]) {
              if (column.type == "file" || column.type == "image") {
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                };
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.rightForm = forms[1];
      this.uploadForm = forms[2];
      this.validated = true;
      return valid;
    },
    fetchRooms: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "ranap/fasilitas/kamar?per_page=9999999999&status=KOSONG"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          this.rooms = result.data.data;
          ////console.log(doctors);
          this.leftForm[1].columns[0].options = this.rooms.map(function(item) {
            item.label = `${item.formatted_kelas} | ${item.nama}  [ ${item.formatted_no_kasur} ]`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          if (this.formSet["id_kamar"]) {
            this.leftForm[1].columns[0].value = this.formSet["id_kamar"];
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchDoctors: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          "dokter?per_page=9999999999"
        );
        ////console.log(result);
        if (result.status == "200") {
          ////console.log(result.data);
          let doctors = result.data.data;
          ////console.log(doctors);
          this.leftForm[2].columns[0].options = doctors.map(function(item) {
            item.label = `${item.kode} | ${item.nama}`;
            item.value = item.id;
            return { label: item.label, value: item.value };
          });
          this.leftForm[2].columns[0].value = this.formSet["id_dokter"];
          this.leftForm.splice(2, 1, this.leftForm[2]);
          ////console.log(this.leftForm);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        ////console.log(result);
        if (result.status == "200") {
          this.leftForm[3].columns[0].options = result.data.data.map((item) => {
            return { value: item.id, label: item.nama };
          });
          if (!this.formSet.id_petugas) {
            this.formSet.id_petugas = this.$store.state.id_petugas || "";
            if (this.formSet.id_petugas) {
              this.leftForm[3].columns[0].value = this.formSet.id_petugas;
            }
          }
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        ////console.log(e);
      }
    },
    handlePopstate(event) {
      console.log("going in");
      this.reset(`/ranap`);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.toReset = (url, stay, noTab) => this.reset(url, stay, noTab);
    if (this.$route.query.id_kamar) {
      this.formSet["id_kamar"] = this.$route.query.id_kamar;
    }
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=${this.$route.params.darurat}`
      );
      ////console.log(result);
      if (result.status == "200") {
        ////console.log('ralan');
        ////console.log(result.data);
        this.ralan = result.data;
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        ////console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        this.formSet["darurat"] = result.data.darurat;
        this.formSet["no_rm"] = result.data.pasien.no_rm;
        this.formSet["id_dokter"] = result.data.id_dokter;

        ////console.log(this.formSet['no_rawat']);
        // this.formSet['id_dokter']=this.ralan.id_dokter;
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      ////console.log(e);
    }
    this.fetchNurses();
    this.fetchDoctors();
    this.fetchRooms();
  },
  created() {
    window.addEventListener("popstate", (event) => this.handlePopstate(event));
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("popstate", (event) =>
      this.handlePopstate(event)
    );
    next();
  },
};
</script>
